import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import InputMask from 'react-input-mask';
import axios from 'axios';
import styles from './Novo_EditarCadastro.module.css';
import { config } from '../../config';
import { UserContext } from '../../context/UserContext';
import { logAction } from '../../services/LogAction'; // Importe a função de log
import Overlay from '../Acessorios/Overlay';

function EditarCadastro() {
    const { cD_CLI } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { codigoCondominio, nomeUsuario, emailUsuario } = useContext(UserContext);

    const [formData, setFormData] = useState({
        nomeCompleto: '',
        CPF: '',
        email: '',
        numeroCelular: '',
        bloco: '',
        unidade: ''
    });

    const [erros, setErros] = useState({});
    const [mensagem, setMensagem] = useState('');
    const [statusAtivo, setStatusAtivo] = useState(true);
    const [showOverlay, setShowOverlay] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showConfirmUpdate, setShowConfirmUpdate] = useState(false);

    useEffect(() => {
        if (state && state.cadastro) {
            const cadastroAtual = state.cadastro;
            setFormData({
                nomeCompleto: cadastroAtual.nM_CLI,
                CPF: cadastroAtual.nR_CPF,
                email: cadastroAtual.email,
                numeroCelular: cadastroAtual.fN_CLI,
                bloco: cadastroAtual.blC_CLI,
                unidade: cadastroAtual.nR_UND,
            });
            setStatusAtivo(cadastroAtual.sT_CLI);
        } else {
            console.error("Nenhum dado de cadastro foi passado.");
        }
    }, [state]);

    const handleInputChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
        if (erros[field]) {
            setErros((prevErros) => ({ ...prevErros, [field]: '' }));
        }
    };

    const handleStatusChange = (event) => {
        const value = event.target.value === 'true';
        setStatusAtivo(value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const novosErros = {};

        if (!formData.nomeCompleto) {
            novosErros.nomeCompleto = "Preencher campo obrigatório: Nome Completo";
        }

        const cpfSemMascara = formData.CPF.replace(/\D/g, '');
        if (!formData.CPF || cpfSemMascara.length !== 11) {
            novosErros.CPF = "Número de CPF inválido.";
        }

        if (!formData.email) {
            novosErros.email = "Preencher campo obrigatório: E-mail";
        }

        const celularSemMascara = formData.numeroCelular.replace(/\D/g, '');
        if (!formData.numeroCelular || celularSemMascara.length !== 11) {
            novosErros.numeroCelular = "Número de celular inválido.";
        }

        if (!formData.bloco) {
            novosErros.bloco = "Preencher campo obrigatório: Bloco";
        }

        if (!formData.unidade) {
            novosErros.unidade = "Preencher campo obrigatório: Unidade";
        }

        if (Object.keys(novosErros).length > 0) {
            setErros(novosErros);
            return;
        }

        setShowConfirmUpdate(true); // Exibe o modal de confirmação para atualizar
    };

    const confirmUpdate = async () => {
        setShowConfirmUpdate(false); // Fecha o modal de confirmação

        try {
            const updatedCadastro = {
                Nome: formData.nomeCompleto,
                Cpf: formData.CPF.replace(/\D/g, ''),
                Email: formData.email,
                Telefone: formData.numeroCelular.replace(/\D/g, ''),
                Condominio: '',
                CodigoCondominio: codigoCondominio,
                Bloco: formData.bloco,
                Unidade: formData.unidade,
                StatusAtivo: statusAtivo,
                CodigoCliente: cD_CLI
            };

            await axios.put(`${config.apiBaseUrl}/Cliente/alterar`, updatedCadastro, {
                withCredentials: true
            });

            logAction('Atualizar Cadastro', { nomeUsuario, emailUsuario }, { cadastroId: cD_CLI });

            setMensagem('Cadastro atualizado com sucesso!');
            setShowOverlay(true);

            setTimeout(() => {
                setMensagem('');
                setShowOverlay(false);
                navigate('/usuario/gerenciar-cadastros');
            }, 5000);
        } catch (error) {
            setMensagem('Erro ao atualizar cadastro: ' + error.message);
            setShowOverlay(true);
        }
    };

    const handleCancel = () => {
        navigate('/usuario/gerenciar-cadastros');
    };

    const handleDelete = () => {
        setShowConfirmDelete(true); // Exibe o modal de confirmação para excluir
    };

    const confirmDelete = async () => {
        setShowConfirmDelete(false); // Fecha o modal de confirmação

        try {
            await axios.delete(`${config.apiBaseUrl}/Cliente/excluir/${cD_CLI}`, {
                data: {
                    AcoesRealizadasPor: {
                        nomeUsuario: nomeUsuario,
                        emailUsuario: emailUsuario
                    }
                },
                withCredentials: true
            });

            logAction('Excluir Cadastro', { nomeUsuario, emailUsuario }, { cadastroId: cD_CLI });

            setMensagem('Cadastro excluído com sucesso!');
            setShowOverlay(true);

            setTimeout(() => {
                setShowOverlay(false);
                navigate('/usuario/gerenciar-cadastros');
            }, 3000);
        } catch (error) {
            setMensagem('Erro ao excluir cadastro: ' + error.message);
            setShowOverlay(true);
        }
    };

    return (
        <div className={styles.formContainer}>
            {showOverlay && (
                <Overlay mensagem={mensagem} isErro={!!mensagem.includes("Erro")} showOverlay={showOverlay} />
            )}

            <form onSubmit={handleSubmit}>
                <div className={styles.formRow}>
                    <label>
                        <strong>Status:</strong>
                        <select
                            value={statusAtivo}
                            onChange={handleStatusChange}
                            className={styles.inputField}
                        >
                            <option value={true}>Ativo</option>
                            <option value={false}>Inativo</option>
                        </select>
                    </label>
                </div>

                <div className={styles.formRow}>
                    <label>
                        <strong>Nome Completo:</strong>
                        <input
                            type="text"
                            value={formData.nomeCompleto}
                            onChange={(e) => handleInputChange('nomeCompleto', e.target.value)}
                            className={`${styles.inputField} ${erros.nomeCompleto ? styles.highlightEmpty : ''}`}
                        />
                        {erros.nomeCompleto && <p className={styles.mensagemErro}>{erros.nomeCompleto}</p>}
                    </label>
                    <label>
                        <strong>CPF:</strong>
                        <InputMask
                            mask="999.999.999-99"
                            value={formData.CPF}
                            onChange={(e) => handleInputChange('CPF', e.target.value)}
                            className={`${styles.inputField} ${erros.CPF ? styles.highlightEmpty : ''}`}
                        />
                        {erros.CPF && <p className={styles.mensagemErro}>{erros.CPF}</p>}
                    </label>
                    <label>
                        <strong>E-mail:</strong>
                        <input
                            type="email"
                            value={formData.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            className={`${styles.inputField} ${erros.email ? styles.highlightEmpty : ''}`}
                        />
                        {erros.email && <p className={styles.mensagemErro}>{erros.email}</p>}
                    </label>
                    <label>
                        <strong>Número do Celular:</strong>
                        <InputMask
                            mask="(99) 99999-9999"
                            value={formData.numeroCelular}
                            onChange={(e) => handleInputChange('numeroCelular', e.target.value)}
                            className={`${styles.inputField} ${erros.numeroCelular ? styles.highlightEmpty : ''}`}
                        />
                        {erros.numeroCelular && <p className={styles.mensagemErro}>{erros.numeroCelular}</p>}
                    </label>
                    <label>
                        <strong>Bloco:</strong>
                        <input
                            type="text"
                            value={formData.bloco}
                            onChange={(e) => handleInputChange('bloco', e.target.value)}
                            className={`${styles.inputField} ${erros.bloco ? styles.highlightEmpty : ''}`}
                        />
                        {erros.bloco && <p className={styles.mensagemErro}>{erros.bloco}</p>}
                        <p className={styles.instrucao}>Caso não haja bloco, preencher com: <strong>-</strong></p>
                    </label>
                    <label>
                        <strong>Unidade:</strong>
                        <input
                            type="text"
                            value={formData.unidade}
                            onChange={(e) => handleInputChange('unidade', e.target.value)}
                            className={`${styles.inputField} ${erros.unidade ? styles.highlightEmpty : ''}`}
                        />
                        {erros.unidade && <p className={styles.mensagemErro}>{erros.unidade}</p>}
                    </label>
                </div>
                <button type="submit" className={styles.submitButton}>Atualizar Cadastro</button>
                <button type="button" className={styles.cancelButton} onClick={handleCancel}>Cancelar</button>
            </form>

            <div className={styles.deleteButtonContainer}>
                <button type="button" className={styles.deleteButton} onClick={handleDelete}>
                    Excluir Cadastro
                </button>
            </div>

            {showConfirmDelete && (
                <div className={styles.confirmOverlay}>
                    <div className={styles.confirmModal}>
                        <p>Você tem certeza que deseja excluir o cadastro?</p>
                        <div className={styles.confirmModalButtons}>
                            <button className={styles.confirmButton} onClick={confirmDelete}>Excluir</button>
                            <button className={styles.cancelButton} onClick={() => setShowConfirmDelete(false)}>Cancelar</button>
                        </div>
                        <p className={styles.confirmWarning}>Essa ação não poderá ser desfeita.</p>
                    </div>
                </div>
            )}

            {showConfirmUpdate && (
                <div className={styles.confirmOverlay}>
                    <div className={styles.confirmModal}>
                        <p>Você tem certeza que deseja atualizar o cadastro?</p>
                        <div className={styles.confirmModalButtons}>
                            <button className={styles.confirmButton} onClick={confirmUpdate}>Atualizar</button>
                            <button className={styles.cancelButton} onClick={() => setShowConfirmUpdate(false)}>Cancelar</button>
                        </div>
                        <p className={styles.confirmWarning}>Essa ação modificará os dados do cadastro.</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EditarCadastro;
